module.exports = __webpack_public_path__ + "img/pic_4.65eb62fa.jpg";